import { Component, OnInit, OnDestroy, ChangeDetectorRef, HostListener, ElementRef } from '@angular/core';
import { DataSharingService } from '../../../data-shering-service/data-sharing.service';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd } from "@angular/router";
import { filter } from 'rxjs/operators';
import { DirectionService } from '../../../../direction.service';
import { AuthService } from 'src/app/auth/auth.service';
import { UsersService } from 'src/app/super-management/user/users.service';
import { BranchesService } from 'src/app/super-management/branch/branches.service';
import {
  getPhPrintingNavIconSrc,
  getPhProductChooserCommandsFromBranchId,
  getPhSystemTitleKeyFromProductId,
  isPhThreeDPrintProductId,
  PH_PRODUCT_ROUTE_3D,
  PH_PRODUCT_ROUTE_PRINT,
} from 'src/app/main-section/ph-printing-table/ph-service-data';
import { syncIsNotAcademyFromCluster, setIsNotAcademyLocalStorage } from 'src/app/utils/is-not-academy';

@Component({
  selector: 'app-navigation-from-printingtable',
  templateUrl: './navigation-from-printingtable.component.html',
  styleUrls: ['./navigation-from-printingtable.component.css']
})
export class NavigationFromPrintingTableComponent implements OnInit, OnDestroy {
  /** לתבנית – אותה לוגיקה כמו ב־right-place */
  readonly getPhPrintingNavIconSrc = getPhPrintingNavIconSrc;
  readonly getPhSystemTitleKeyFromProductId = getPhSystemTitleKeyFromProductId;

  public printingService: string = '';
  public printingServices: { name: string }[] = [];
  private dataServiceSubscription: Subscription;
  isDarkMode: boolean = false;

  userId: string;
  userIsAuthenticated = false;
  private authStatusSub: Subscription;
  myPrintingServicesList: string[];
  myBranchesList: string[];
  branches: any[] = [];
  branchName: string = '';
  isLoading: boolean = false;
  realBranchesObjects: any[] = [];
  realBranchesObjectsSelected: any[] = [];
  isNavOpen: boolean = false;
  isRTL: boolean = true;

  private rolesSubscription: Subscription;
  roles: string[] = [];
  isSU: boolean = false;
  currentRoute: string = '';

  constructor(
    private dataSharingService: DataSharingService,
    private router: Router,
    private directionService: DirectionService,
    private authService: AuthService,
    private usersService: UsersService,
    private branchesService: BranchesService,
    private cd: ChangeDetectorRef,
    private eRef: ElementRef,
  ) { }

  @HostListener('document:click', ['$event'])
  onClick(event: Event) {
    if (this.isNavOpen && !this.eRef.nativeElement.contains(event.target)) {
      this.isNavOpen = false;
    }
  }

  async ngOnInit() {
    this.isLoading = true;
    this.currentRoute = this.router.url;
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.currentRoute = event.urlAfterRedirects;
      this.cd.detectChanges();
    });
    this.directionService.isDarkMode$.subscribe(isDarkMode => {
      this.isDarkMode = isDarkMode;
    });

    this.printingServices = this.dataSharingService.getPrintingServices();

    this.dataServiceSubscription = this.dataSharingService.getPrintingService().subscribe((value) => {
      this.printingService = value;
    });

    this.dataServiceSubscription = this.dataSharingService.getBranch().subscribe((value) => {
      this.branchName = value;
    });

    this.userId = this.authService.getUserId();
    this.userIsAuthenticated = this.authService.getIsAuth();
    this.authStatusSub = this.authService
      .getAuthStatusListener()
      .subscribe(isAuthenticated => {
        this.userIsAuthenticated = isAuthenticated;
        this.userId = this.authService.getUserId();
      });

    this.rolesSubscription = this.authService.roles$.subscribe(roles => {
      this.roles = roles;
      if (this.roles.includes('su')) {
        this.isSU = true;
      } else {
        this.isSU = false;
      }
      this.cd.detectChanges();
    });

    if (this.userId) {
      this.usersService.getUser(this.userId).subscribe((user) => {
        if (!user) {
          this.refreshPageThroughQr();
        }
        if (user.home_printingServices_list?.length > 0 && user.home_branches_list?.length > 0) {
          this.myPrintingServicesList = [...user.home_printingServices_list];
          this.myBranchesList = [...user.home_branches_list];
        } else {
          if (this.printingService && this.printingService !== '' && this.branchName && this.branchName !== '') {
            this.myPrintingServicesList = [this.printingService];
            this.myBranchesList = [this.branchName];
          } else {
            if (localStorage.getItem('printingService') && localStorage.getItem('printingService') !== '' &&
              localStorage.getItem('branch') && localStorage.getItem('branch') !== '') {
              this.printingService = localStorage.getItem('printingService');
              this.branchName = localStorage.getItem('branch');
              this.myPrintingServicesList = [this.printingService];
              this.myBranchesList = [this.branchName];
            } else {
              this.goHome();
            }
          }
        }
      });
      this.fetchBranchesWithRetry(3);
    } else {
      this.goHome();
    }
  }

  async fetchBranchesWithRetry(retries: number) {
    try {
      this.realBranchesObjects = await this.branchesService.getAllBranches().toPromise();
      if (this.realBranchesObjects && this.realBranchesObjects.length > 0) {
        for (let branchName of this.myBranchesList) {
          // console.log('Branch name:', branchName);
          const selectedBranchIndex = this.realBranchesObjects.findIndex(
            (branch: any) => branch.name === branchName
          );
          if (selectedBranchIndex !== -1) {
            this.realBranchesObjectsSelected.push(this.realBranchesObjects[selectedBranchIndex]);
          } else {
            this.realBranchesObjectsSelected.push({ name: branchName });
          }
        }
      }
      // console.log('Real branches objects:', this.realBranchesObjectsSelected);
      this.isLoading = false;
    } catch (error) {
      // console.error('Error fetching and transforming branches:', error);
      if (retries > 0) {
        // console.log(`Retrying... (${3 - retries + 1})`);
        this.fetchBranchesWithRetry(retries - 1);
      } else {
        if (localStorage.getItem('printingService') && localStorage.getItem('branch')) {
          this.refreshPageThroughQr();
        } else {
          this.goHome();
        }
      }
    }
  }

  ngOnDestroy() {
    if (this.authStatusSub) {
      this.authStatusSub.unsubscribe();
    }
    if (this.dataServiceSubscription) {
      this.dataServiceSubscription.unsubscribe();
    }
    if (this.rolesSubscription) {
      this.rolesSubscription.unsubscribe();
    }
  }

  async chaingePrintingServiceAndBranch(selectedService: string, selectedBranch: string) {
    if (!selectedService || !selectedBranch) {
      return;
    }
    
    this.isLoading = true;
    try {
      await this.dataSharingService.setPrintingService(selectedService);
      await this.dataSharingService.setBranch(selectedBranch);
      this.authService.updateAuthData(selectedService, selectedBranch);
      if (selectedService === 'ph') {
        setIsNotAcademyLocalStorage(false);
      } else {
        const cluster = this.realBranchesObjects?.find(
          (b: any) => b.name === selectedBranch
        );
        syncIsNotAcademyFromCluster(cluster, selectedService);
      }
      
      this.usersService.updateUserPlace(selectedService, selectedBranch).subscribe(response => {
        this.myPrintingServicesList = [...response.home_printingServices_list];
        this.myBranchesList = [...response.home_branches_list];
        this.closeMainNav();
        this.isLoading = false;
        this.realBranchesObjectsSelected = [];
        if (this.realBranchesObjects.length > 0) {
          for (let branchName of this.myBranchesList) {
            const selectedBranchIndex = this.realBranchesObjects.findIndex(
              (branch: any) => branch.name === branchName
            );
            if (selectedBranchIndex !== -1) {
              this.realBranchesObjectsSelected.push(this.realBranchesObjects[selectedBranchIndex]);
            } else {
              this.realBranchesObjectsSelected.push({ name: branchName });
            }
          }
        }
      });
      if (selectedService === 'ph') {
        await this.dataSharingService.setProduct(selectedBranch);
      }
      
      const currentUrl = this.router.url;
      if (currentUrl.includes('/phprint')) {
        if (selectedService !== 'ph') {
          this.router.navigate(['/print']);
        }
      } else {
        if (selectedService === 'ph') {
          this.router.navigate(['/phprint']);
        }
      }
    } catch (error) {
      this.isLoading = false;
    }
  }

  refreshPageThroughQr() {
    if (localStorage.getItem('printingService') && localStorage.getItem('branch')) {
      this.router.navigate(['/qr/' + localStorage.getItem('printingService') + '/' + localStorage.getItem('branch')]);
    } else {
      this.goHome();
    }
  }

  goHome() {
    this.router.navigate(['/']);
  }

  /** רק ל־/phprint: מוצר תלת־ממד לפי מזהה סניף/מוצר (כמו ב־ph-service-data) */
  private isPhprintRoute(): boolean {
    const u = (this.currentRoute || this.router.url || '').split('?')[0];
    return u.includes('/phprint');
  }

  /** תואם ל־type === '3Dprint' במסלול PH: FDM/MJF/SLA או מזהה 3Dprint */
  private isPhBranchThreeDPrintChooser(): boolean {
    const id = (this.branchName || '').trim();
    return isPhThreeDPrintProductId(id) || id === '3Dprint';
  }

  /** מפתח תרגום לכפתור «חזרה לבחירה» — ב־/phprint מבדיל תלת־ממד מול הדפסה רגילה */
  getPhChangeChooserLabelKey(): string {
    if (this.printingService !== 'ph') {
      return 'choose-branch.back-to-last-printer';
    }
    if (this.isPhprintRoute() && !this.isPhBranchThreeDPrintChooser()) {
      return 'choose-branch.change-ph-print-product';
    }
    return 'choose-branch.back-to-last-product';
  }

  goToBranch() {
    console.log('Navigating to branch:', this.printingService, this.branchName);
    if (this.printingService !== 'ph') {
      this.router.navigate(['/branch/' + this.branchName]);
    } else if (this.isPhprintRoute()) {
      // Mark navigation source so /phprint can mimic plotter product-switch methodology.
      try {
        localStorage.setItem('ph_nav_source', 'printingtable');
      } catch {
        /* ignore */
      }
      this.router.navigate(
        this.isPhBranchThreeDPrintChooser() ? [PH_PRODUCT_ROUTE_3D] : [PH_PRODUCT_ROUTE_PRINT]
      );
    } else {
      this.router.navigate(getPhProductChooserCommandsFromBranchId(this.branchName));
    }
  }

  toggleMainNav() {
    this.isNavOpen = !this.isNavOpen;
  }

  closeMainNav() {
    this.isNavOpen = false;
  }

  goToPrintingQueue() {
    let attempts = 0;
    const maxAttempts = 30;
    const intervalTime = 200;

    const interval = setInterval(() => {
      const branchUnique = this.realBranchesObjectsSelected[0]?.plotter?.unique;

      if (branchUnique) {
        console.log('Branch unique ID found:', branchUnique);
        clearInterval(interval);
        this.router.navigate(['/queue/' + branchUnique]);
        return;
      }

      attempts++;

      if (attempts >= maxAttempts) {
        clearInterval(interval);
        console.warn('Could not find branch unique ID after 20 attempts');
      }
    }, intervalTime);
  }

  getPrintingService(index: number) {
    if (this.myPrintingServicesList?.length > 0 &&
      (this.myPrintingServicesList[index] === 'plotter' ||
        this.myPrintingServicesList[index] === 'ph')) {
      return this.myPrintingServicesList[index];
    } else {
      if (this.realBranchesObjectsSelected?.length > 0 && this.realBranchesObjectsSelected[index]?.express?.isPicsPrinter) {
        return "pics";
      } else {
        return "express";
      }
    }
  }
}
